module.exports = __webpack_public_path__ + "1.0.0-d5234419/img/step2.c457e560.png";